__turbopack_context__.v({
  "className": "gilroy_2ac1efa0-module__gsTtHa__className",
  "variable": "gilroy_2ac1efa0-module__gsTtHa__variable",
});
